<template lang="pug">
  .scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
    :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tabHead")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
        tbody.table__body(v-for="item in tabData")
          tr.table__row
            td.table__cell
              .table__cell-content
                .table__cell-content {{item.last_name + " " + item.first_name + " " + item.fathers_name }}
            td.table__cell
              .table__cell-content {{item.email}}
            td.table__cell.fixed
              .table__cell-content.table__cell-content_align-right
                .form-switch.form-switch_small.form-switch_transparent.table__cell-control
                  label.form-switch__label
                    input.form-switch__input(
                    type="checkbox"
                    v-model="item.is_active"
                    @click.prevent="switchChange(item)"
                    )
                    .form-switch__outline
                    .form-switch__switch
                router-link.button.button_square.table__cell-control(
                :to="{name: linkForEditor, params: {id: item.id}}"
                )
                  img(src="@/assets/images/icons/icon-edit.svg")
                button.button.button_square.table__cell-control(
                @click.prevent="onButtonDeleteClick(item)"
                )
                  img(src="@/assets/images/icons/trash.svg")
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "AccountsRegistryScrollFixTable",
  props: {
    tabData: {
      type: Array,
      default: () => ([])
    },
    tabHead: {
      type: Array,
      default: () => ([])
    },
    linkForEditor: {
      type: String,
      default: ""
    }
  },
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  },
  methods: {
    switchChange(item) {
      this.$emit("switch-change", item);
    },
    onButtonDeleteClick(item) {
      this.$emit("on-button-delete-click", item);
    }
  },
  mounted() {

  }
};
</script>
